import type { IconButtonProps } from 'd2/components/ButtonV2/IconButton/types'
import type { Variant } from 'd2/components/ButtonV2/base/types'

export const PREMIUM_PARTNER_COLORS = [
  'appleMusicBlack',
  'facebookBlue',
  'instagramBlack',
  'spotifyGreen',
  'twitterBlue',
  'youtubeGray',
  'youtubeRed',
] as const

type SolidButtonOwnProps = {
  // NOTE: If we could dynamically pull the types from colors and branding colors objects that would be ideal.
  color?: typeof PREMIUM_PARTNER_COLORS[number] | 'faintGray' | 'primary' | 'secondary' | 'smartLinkButtonBlack' | 'tertiary' | 'white'
}

type RestIconButtonProps = {
  variant?: Variant
}

export type SolidButtonProps = Omit<Omit<IconButtonProps, keyof RestIconButtonProps>, keyof SolidButtonOwnProps> & SolidButtonOwnProps
